import IPasswordProps from "./IPasswordProps";
import { Card, CardHeader, mergeClasses, Text, Tooltip } from '@fluentui/react-components';
import useStyleUtils from '../../utilities/styles';
import DeletePassword from "../deletePassword/DeletePassword";
import EditPassword from '../editPassword/EditPassword';
import Tabs from "./tabs/Tabs";
import { LockClosed16Filled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

const Header = (props: IPasswordProps) => {
    const { t } = useTranslation();
    const style = useStyleUtils();
    
    const titleStyles = mergeClasses(style.w100, style.dFlex, style.alignItemsCenter),
        textSyles = mergeClasses(style.dInlineBlock, style.mrAuto);

    return (
        <div className={titleStyles}>
            {
                props.password.isPersonal &&
                <Tooltip content={t("passwords.personal")} relationship="label">
                    <LockClosed16Filled className={style.mr2} />
                </Tooltip>
            }
            <Text weight="semibold" className={textSyles}>{props.password.label}</Text>
            <div className={style.dInlineBlock}>
                <EditPassword passwordId={props.password.id} onUpdate={props.onUpdate} />
                <DeletePassword passwordId={props.password.id} onDelete={props.onUpdate} />
            </div>
        </div>
    );
};

export default function Password(props: IPasswordProps) {
    const style = useStyleUtils();

    return (
        <Card className={style.mb3}>
            <CardHeader header={<Header {...props} />} />
            <Tabs password={props.password} />
        </Card>
    );
}